import type { Deck, Event, Player } from "@liga/shared";
import { Combobox } from "./Combobox";

export interface FilterValues {
  playerId: number | "";
  eventId: number | "";
  deckId: number | "";
  from: string;
  to: string;
}

export const emptyFilters: FilterValues = {
  playerId: "",
  eventId: "",
  deckId: "",
  from: "",
  to: "",
};

interface Props {
  values: FilterValues;
  onChange: (next: FilterValues) => void;
  players: Player[];
  decks: Deck[];
  events: Event[];
}

export function Filters({
  values,
  onChange,
  players,
  decks,
  events,
}: Props) {
  function update<K extends keyof FilterValues>(key: K, value: FilterValues[K]) {
    onChange({ ...values, [key]: value });
  }

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4 grid grid-cols-1 md:grid-cols-5 gap-3">
      <Combobox
        label="Player"
        value={values.playerId}
        onChange={(v) => update("playerId", v)}
        options={players.map((p) => ({ value: p.id, label: p.name }))}
        placeholder="Buscar player..."
      />
      <Combobox
        label="Evento"
        value={values.eventId}
        onChange={(v) => update("eventId", v)}
        options={events.map((e) => ({ value: e.id, label: e.name }))}
        placeholder="Buscar evento..."
      />
      <Combobox
        label="Deck"
        value={values.deckId}
        onChange={(v) => update("deckId", v)}
        options={decks.map((d) => ({ value: d.id, label: d.name }))}
        placeholder="Buscar deck..."
      />
      <DateInput
        label="De"
        value={values.from}
        onChange={(v) => update("from", v)}
      />
      <DateInput
        label="Até"
        value={values.to}
        onChange={(v) => update("to", v)}
      />
      <div className="md:col-span-5 flex justify-end">
        <button
          type="button"
          onClick={() => onChange(emptyFilters)}
          className="text-xs text-slate-500 hover:text-brand-700"
        >
          Limpar filtros
        </button>
      </div>
    </div>
  );
}

interface DateInputProps {
  label: string;
  value: string;
  onChange: (v: string) => void;
}

function DateInput({ label, value, onChange }: DateInputProps) {
  return (
    <label className="block text-sm">
      <span className="block text-slate-600 mb-1">{label}</span>
      <input
        type="date"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full rounded border border-slate-300 bg-white px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-brand-500"
      />
    </label>
  );
}
